import React, { FC } from 'react';
import { Button, CircularProgress } from '@material-ui/core';
import SendIcon from '@material-ui/icons/Send';
import CustomComposer from '../CustomComposer/CustomComposer';
import { InputToolbar, InputToolbarProps } from 'react-web-gifted-chat';
import useStyles from './styles';
import { useTheme } from '@material-ui/core/styles';

interface ICustomInputToolbar {
  onSend: () => void;
  isInputHaveValue: boolean;
  isSendingMessage: boolean;
  disabled?: boolean;
}

const CustomInputToolbar: FC<ICustomInputToolbar & InputToolbarProps> = (
  props,
) => {
  const { isInputHaveValue, onSend, isSendingMessage, disabled } = props;

  const classes = useStyles();
  const theme = useTheme();

  return (
    <InputToolbar
      {...props}
      containerStyle={{ borderTopWidth: 0, margin: theme.spacing(2) }}
      renderComposer={(_) => <CustomComposer {..._} multiline />}
      renderSend={() => {
        return (
          <Button
            disabled={!isInputHaveValue || disabled}
            onClick={() => onSend()}
            className={classes.sendButton}>
            {isSendingMessage ? (
              <CircularProgress size={24} color="inherit" />
            ) : (
              <SendIcon fontSize="large" />
            )}
          </Button>
        );
      }}
    />
  );
};

export default CustomInputToolbar;
